// Module
var code = "<h3>Documentation</h3> <div id=\"listCard\" class=\"card mb-10\"> <h5>Supporting Documentation</h5> <hr class=\"mb-8\"/> <div id=\"documentListDiv\"> </div> <div class=\"flex justify-center items-left mt-10\"> <button id=\"step1Btn\" onclick=\"thsTab.buildUploadModal()\">Upload Document</button> </div> </div> ";
// Exports
export default code;